
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayAcuatorPiston50 as ObiTwowayAcuatorPiston50Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-acuator-piston-50.js';
 
 
 

 
 export const ObiTwowayAcuatorPiston50 = createComponent({
   react: React,
   tagName: 'obi-twoway-acuator-piston-50',
   elementClass: ObiTwowayAcuatorPiston50Element,
   events: {
     
   }
  });
 
 